<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Proveedores</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Proveedores</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <form autocomplete="off" [formGroup]="formHeader">
    <!--Card content-->
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
        <div></div>
        <button type="button" mdbBtn color="info" (click)="showModalAdd()" size="sm" mdbWavesEffect>Agregar</button>
      </div>
      <div class="filtro-body">
        <div class="row">
          <div class="col" style="max-width: 150px">
            <div class="md-form">
              <input value="" type="text" class="form-control" placeholder="" required formControlName="nombre" />
              <label for="rutproveedor">Nombre Proveedor</label>
              <!-- <div *ngIf="formHeader.get('nombre').invalid && (formHeader.get('nombre').dirty || formHeader.get('rut').touched)">
                <mdb-error *ngIf="formHeader.get('nombre').hasError('required')">Ingrese Proveedor </mdb-error>
              </div> -->
            </div>
          </div>
          <div class="col" style="max-width: 150px">
            <div class="md-form">
              <input value="" type="text" class="form-control" placeholder="" required formControlName="rut"
                formatRut />
              <label for="rutproveedor">RUT Proveedor</label>
              <!-- <div *ngIf="formHeader.get('rut').invalid && (formHeader.get('rut').dirty || formHeader.get('rut').touched)">
                <mdb-error *ngIf="formHeader.get('rut').hasError('required')">Ingrese Proveedor </mdb-error>
              </div> -->
            </div>
          </div>
          <!-- <div class="col" style="max-width: 300px">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect (click)="abrirModalSeleccionarProveedor()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
            <h6 class="text-info" *ngIf="proveedorSeleccionado" style="display: contents">
              {{ proveedorSeleccionado.nombre }}
            </h6>
          </div> -->
        </div>
      </div>
    </div>

    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar()">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </form>
</div>

<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive" *ngIf="listaRegistros">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Rut</th>
            <th scope="col">Nombre</th>
            <th scope="col">giro</th>
            <th scope="col">Mail</th>
            <th scope="col">Teléfono</th>
            <th scope="col">Prov. de canje</th>
            <th scope="col">No aplica f. venc.</th>
            <th scope="col">Activo</th>
            <th scope="col"></th>
            <th scope="col"></th>
            <!-- <th scope="col"></th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && listaRegistros?.length === 0">
            <td colspan="100%" style="text-align: center">No se encontró información</td>
          </tr>
          <tr *ngFor="let reg of listaRegistros">
            <td>{{ reg.cliente_proveedor.rutFormato | rut }}</td>
            <td class="text-wrap">{{ reg.cliente_proveedor.nombre }}</td>
            <td class="text-wrap">{{ reg.cliente_proveedor.giro }}</td>
            <td>{{ reg.cliente_proveedor.mail_contacto }}</td>
            <td>{{ reg.direccion.fono_movil }}</td>
            <td class="text-center">
              <i *ngIf="reg.cliente_proveedor.es_canje" class="fa fa-check-circle fa-lg green-text"></i>
            </td>
            <td class="text-center">
              <i *ngIf="reg.cliente_proveedor.no_aplica_fec_venc" class="fa fa-check-circle fa-lg green-text"></i>
            </td>

            <td>
              <mdb-badge pill="true" success="true" *ngIf="reg.cliente_proveedor.activo">Activo</mdb-badge>
              <mdb-badge pill="true" warning="true" *ngIf="!reg.cliente_proveedor.activo">Inactivo</mdb-badge>
            </td>
            <td>
              <button class="btn-actions-sm" color="info" mdbBtn type="button" size="sm" mdbWavesEffect mdbTooltip="Ver"
                placement="right" (click)="view(reg)">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
            <td>
              <button class="btn-actions-sm" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
                mdbTooltip="Editar" placement="right" (click)="edit(reg)">
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
            </td>
            <!-- <td>
              <button class="btn-actions-sm" color="primary" mdbBtn type="button" size="sm" mdbWavesEffect
                mdbTooltip="Eliminar" placement="right" (click)="delete(reg)">
                <mdb-icon fas icon="trash"></mdb-icon>
              </button>
            </td> -->
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaRegistros?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<app-add-edit-proveedor (onSuccess)="buscar(paginationContext.CurrentPage)"></app-add-edit-proveedor>